import React from "react";
import { ImageIcon, FileIcon } from "../../assets/icon";

interface AttachmentPopupProps {
  isUploading: boolean;
  isUploadingFile: boolean;
  handleFileSelection: (
    e: React.ChangeEvent<HTMLInputElement>,
    type: "image" | "file",
  ) => void;
}

export const AttachmentPopup = ({
  isUploading,
  isUploadingFile,
  handleFileSelection,
}: AttachmentPopupProps) => {
  return (
    <div
      className={`absolute bottom-[60px] left-0 bg-white shadow-lg rounded-lg p-4 z-50 transition-transform`}
    >
      <h2 className="text-sm font-bold mb-2">Attach</h2>
      <div className="flex space-x-4">
        <label className="flex flex-col items-center cursor-pointer">
          <ImageIcon className="w-6 h-6 text-gray-600 mb-1" />
          <span className="text-xs">Photo</span>
          <input
            type="file"
            accept="image/*"
            className="hidden"
            onChange={(e) => handleFileSelection(e, "image")}
            disabled={isUploading}
          />
        </label>
        <label className="flex flex-col items-center cursor-pointer">
          <FileIcon className="w-6 h-6 text-gray-600 mb-1" />
          <span className="text-xs">File</span>
          <input
            type="file"
            className="hidden"
            onChange={(e) => handleFileSelection(e, "file")}
            disabled={isUploadingFile}
          />
        </label>
      </div>
    </div>
  );
};
